import V3Adapter from './v3';

export default class ApplicationAdapter extends V3Adapter {}
